import React, { useState } from "react";
import Breadcrumb from "./Breadcrumb";
import Accesslevel from "./Accesslevel";
import Features from "./Features";

export const Content = (props) => {
  const [accesslevelid, setaccesslevelID] = useState("");

  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb />
          <div className="row">
            <div className="col-md-5">
              <Accesslevel accessid={setaccesslevelID} />
            </div>
            <div className="col-md-7">
              <Features accesslevelid={accesslevelid} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
